import { Props } from "../../../types";
import { classNameParser } from "../../../helpers";

import "./style.css";

type AlertStatusProps = Props<{
  status?: "warning" | "error" | "valid" | "info";
}>;

export const AlertBanner = (props: AlertStatusProps) => (
  <div className={classNameParser(`alert-banner--container ${props.status || ""}`, props.className)} id={props?.id} style={props.style}>{props.children}</div>
);

export const AlertSection = (props: AlertStatusProps) => (
  <div className={classNameParser(`alert-section--container ${props.status || ""}`, props.className)} style={props.style}>{props.children}</div>
);
